import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

import Meta from "../../components/Meta";
import {
  HABERDASHERY_SHOP_KEY,
  READY_MADE_SHOP_KEY,
  SHOP_PATHS,
  TEXTILE_SHOP_KEY,
} from "../../constants/shopMeta";

import "./WishlistScreen.css";

export default function WishlistScreen() {
  return (
    <main className="wishlist-screen">
      <Meta
        title="Wishlist | Academy Costumes London"
        description="Your Academy Costumes London wishlist."
        robots="noindex, nofollow"
      />

      <section className="wishlist-screen__panel">
        <Heart size={34} aria-hidden="true" />
        <p>Wishlist</p>
        <h1>Your saved pieces</h1>
        <span>
          Wishlist storage is not connected yet. Continue browsing the shops and
          add this feature when account-level saved products are ready.
        </span>
        <div>
          <Link to={SHOP_PATHS[HABERDASHERY_SHOP_KEY]}>Haberdashery</Link>
          <Link to={SHOP_PATHS[TEXTILE_SHOP_KEY]}>Textiles</Link>
          <Link to={SHOP_PATHS[READY_MADE_SHOP_KEY]}>Ready-Made</Link>
        </div>
      </section>
    </main>
  );
}
